<drawer [title]="('Add/Edit' | translate)+ ' ' + formulaType"
	[showHeaderButtons]="true"
	[hideDelete]="true"
	[hideCancel]="false"
	[hideSave]="false"
	[noContentPadding]="true"
	[isClosed]="false"
	[embedded]="isEmbedded"
	(saveEvent)="addFormulaToCost()"
	(cancelEvent)="cancelCostFormula()"
	(closeEvent)="cancelCostFormula()"
	class="text-left in-modal-drawer">
	<div class="drawer-content drawer-direct-content">
		<div class="d-flex overflow-hidden mh-100 h-100 w-100 flex-column">
			<div class="mb-0 no-gutters row h-100 overflow-hidden w-100">
				<div class="col list-determinants h-100 mh-100">
					<div class="d-flex overflow-hidden mh-100 h-100 flex-column flex-grow-0 py-3 pl-3 pr-2">
						<search-input-row [searchVar]="filter" placeholderText="{{ 'Search' | translate }}" [disableAddition]="true"
						(onSearchVarUpdate)="filter = $event" [bottomSpacing]="false" class="search-input-row mb-3"></search-input-row>
						<div class="list-group">
							<draggable-list-group-items
								[guides]="costView.guides | filterBy: {title: filter}"
								[formFields]="costView.formFields | filterBy: {title: filter}"
								[formFieldsFilter]="costView.formFieldsGroup | filterBy: {title: filter}"
								[systemFields]="costView.systemFields"
								[groups]="costView.groups | filterBy: {name: filter}"
								[isDeterminant]="costView.formulaType == 'determinant'" [idAsSlugMode]="costView.idAsSlugMode">
							</draggable-list-group-items>
						</div>
					</div>
				</div>
				<div class="col pl-2 pb-3 query-builder">
					<infix-formula-builder #infixBuilder [costView]="costView" [formulaValue]="costView.formula"
						[propertiesLoaded]="costView.propertiesLoaded" [formulaLoaded]="costView.formulaLoaded"
						(formulaChange)="formulaChange($event)"></infix-formula-builder>
				</div>
			</div>
		</div>
	</div>
</drawer>